import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import TruncatedEllipsis from '../../../shared/truncated-ellipsis';
import EditorsManageWireCallout from '../../../editors-manage-wire/editors-manage-wire-callout';

const Header = styled.div`
  line-height: 130%;

  & > .callout {
    display: inline;
    button {
      margin-top: 8px;
      z-index: 1;
    }
  }

  & > h2 {
    margin-left: 0px;
    margin-right: 0px;
    margin-top: ${props => (props.theme.isMobile ? 0 : 5)}px;
    margin-bottom: 0px;

    > a {
      color: ${props => props.theme.bodyColor};
      font-family: ${props => props.theme.fontFamilyHeader};
      font-weight: ${props => props.theme.fontWeightBold};
      font-size: 19px;

      &:hover {
        text-decoration: none;
      }
    }
  }
`;

export default function WireTitle({ wire, showEditorManageTools, clickHandler }) {
  const { isMobile, isMobileOrTablet } = React.useContext(ThemeContext);
  const showEditorManageWire = showEditorManageTools && !isMobile
    && (_.get(window, 'Livewire.currentUser.profile.canModifyWiresOfOthers') || wire.ownedByCurrentUser);
  // NOTE: this is acutally 3, 2 and 1 we want but ellipsis.js seems to show one less.
  /* eslint-disable no-nested-ternary */
  const lines = isMobile ? 4 : isMobileOrTablet ? 3 : 2;

  return (
    <Header>
      {
        showEditorManageWire && (
          <EditorsManageWireCallout wire={
            {
              wire_id: wire.id,
              title: wire.title,
              editors_picked: wire.editorsPicked,
              published_at: wire.publishedAt,
              featured_count: wire.featuredCount,
              wire: {
                slug: wire.slug,
                user_id: wire.userId || 0,
              },
              profile: {
                name: wire.profile.name,
                profile_picture_url: wire.profile.profilePictureUrl,
              },
            }
          }
          />
        )
      }
      <h2>
        <a href={`/wires/${wire.slug}`} onClick={clickHandler}>
          <TruncatedEllipsis
            lines={lines}
            summary={wire.title}
            useReadMore={false}
            hasTags={false}
          />
        </a>
      </h2>
    </Header>
  );
}

WireTitle.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    userId: PropTypes.number,
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    firstPublishedAt: PropTypes.string,
    publishedAt: PropTypes.string.isRequired,
    ownedByCurrentUser: PropTypes.bool,
    editorsPicked: PropTypes.bool,
    featuredCount: PropTypes.number.isRequired,
    profile: PropTypes.shape({
      name: PropTypes.string.isRequired,
      profilePictureUrl: PropTypes.string,
    }).isRequired,
  }).isRequired,
  showEditorManageTools: PropTypes.bool,
  clickHandler: PropTypes.func,
};

WireTitle.defaultProps = {
  showEditorManageTools: true,
  clickHandler: null,
};
